import { fromEither, none } from 'fp-ts/lib/Option';
import * as t from 'io-ts';
import { createOptionFromNullable } from 'io-ts-types';
import { NonEmptyString } from 'io-ts-types/lib/NonEmptyString';
import { fallback } from 'io-ts-types/lib/fallback';
import queryString from 'query-string';
import { useMemo } from 'react';
import extractArrayHeadCodec from '../lib/extractArrayHeadCodec';

const QS = t.exact(
  t.type({
    q: fallback(
      createOptionFromNullable(extractArrayHeadCodec(NonEmptyString))
    )(none),
    countryCode: fallback(
      createOptionFromNullable(extractArrayHeadCodec(NonEmptyString))
    )(none),
  }),
  'QS'
);
type QS = t.TypeOf<typeof QS>;

const empty: QS = { q: none, countryCode: none };

export default function useQueryParams(locationSearch: string): QS {
  return useMemo(
    () =>
      fromEither(QS.decode(queryString.parse(locationSearch)))
        .map(qs => ({
          ...qs,
          countryCode: qs.countryCode.map(
            cc => cc.toUpperCase() as NonEmptyString
          ),
        }))
        .getOrElse(empty),
    [locationSearch]
  );
}
